"use client";

import { useState, useEffect } from "react";
import axios from "axios";
import Image from "next/image";
import Loader from "@/components/Loader/Loader";
import { useRouter } from "next/navigation";
import { getAcademicYearOptions } from "@/utils/utils";

function PhotosPage() {
  const [albums, setAlbums] = useState<
    { title: string; imageUrl: string; eventName: string }[]
  >([]);
  const initialOptions = getAcademicYearOptions();
  const [academicYearOptions, setAcademicYearOptions] =
    useState(initialOptions);
  const [selectedYear, setSelectedYear] = useState<number>(
    new Date().getFullYear(),
  );
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const options = getAcademicYearOptions();
    setAcademicYearOptions(options);
    if (!options.find((opt) => opt.value === selectedYear.toString())) {
      setSelectedYear(parseInt(options[options.length - 1].value, 10));
    }
    fetchAlbums(selectedYear);
  }, [selectedYear]);

  const fetchAlbums = async (year: any) => {
    setLoading(true);
    try {
      const response = await axios.post("/api/photo", { year: parseInt(year) });
      const data = response.data;
      // console.log(data, "dataa");
      const albumData = data.events.map((event: any) => {
        const title = event?.attributes?.title ?? "Unknown Event";
        const firstWord = title.split(" ")[0];
        const imageLinks = JSON.parse(event?.attributes?.image_link || "[]");
        const imageUrl = imageLinks[0];

        return {
          title: firstWord,
          imageUrl,
          eventName: title,
        };
      });

      setAlbums(albumData || []);
    } catch (error) {
      console.error("Error fetching albums:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleYearClick = (year: number) => {
    setSelectedYear(year);
  };

  const handleEventClick = (eventName: string) => {
    router.push(`/photos/${selectedYear}/${eventName.replace(/ /g, "%20")}`);
  };

  return (
    <>
      <div
        style={{ alignItems: "flex-start", width: "100%", padding: "0 20px" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
          }}
        >
          {academicYearOptions.map((year: any) => (
            <button
              key={year.value}
              onClick={() => handleYearClick(year.value)}
              style={{
                width: "100px",
                height: "50px",
                borderRadius: "50px",
                padding: "10px 20px",
                cursor: "pointer",
                backgroundColor:
                  selectedYear == year.value
                    ? "rgb(220 230 247)"
                    : "var(--Full-White, #FFF)",
                color: selectedYear == year.value ? "rgb(21 91 204)" : "#000",
                border:
                  selectedYear == year.value
                    ? "1px solid rgb(21 91 204)"
                    : "1px solid #000",
                transition: "background-color 0.3s, border 0.3s",
                margin: "10px",
              }}
            >
              {year.value}
            </button>
          ))}
        </div>

        {loading && <Loader />}
        {!loading && albums.length === 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              textAlign: "center",
            }}
          >
            No albums available for {selectedYear}
          </div>
        )}
        {!loading && albums.length > 0 && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "2rem",
            }}
          >
            {albums.map((album) => (
              <div
                key={album.title}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                  width: "250px",
                }}
                onClick={() => handleEventClick(album.title)}
              >
                <div
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #5356E5, #e8adbe)",
                    borderRadius: "8px",
                    padding: "0.5rem",
                    cursor: "pointer",
                    textAlign: "center",
                    margin: "20px",
                  }}
                >
                  <div
                    className="album-container"
                    onClick={() => handleEventClick(album.title)}
                  >
                    <div className="image-wrapper">
                      {album?.imageUrl ? (
                        <div
                          style={{
                            width: "250px",
                            aspectRatio: "4/3",
                            display: "flex",
                            overflow: "hidden",
                          }}
                        >
                          <Image
                            src={album.imageUrl}
                            fill
                            alt={album.title}
                            className="album-image"
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                      ) : (
                        <div>No Image Available</div>
                      )}

                      <div className="overlay">
                        <div className="explore-button">Explore</div>
                      </div>
                    </div>
                    <span style={{ color: "white" }}>{album.title}</span>

                    <style jsx>{`
                    .image-wrapper {
                      position: relative;
                      border-radius: 12px;
                      overflow: hidden;
                    }
                    .album-image {
                      display: block;
                      transition: transform 0.3s ease, filter 0.3s ease;
                    }
                    .overlay {position: absolute;top: 0;left: 0;width: 100%; height: 100%; 
                    display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.5); 
                    /* Dark transparent overlay */ opacity: 0; transition: opacity 0.3s ease; }
                  .explore-button { display: flex; padding: 0.437rem 1.5rem;
                   justify-content: center; align-items: center; border-radius: 5rem; background-color: var(--Primary, #3F41D1); color: var(--Full-White, #FFF); }
                    }
                    .album-container:hover .album-image {
                      transform: scale(1.05);
                      filter: blur(2px);
                    }
                    .album-container:hover .overlay {
                      opacity: 1;
                    }
                  `}</style>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default PhotosPage;
